const binding = { modules: {}, dataActions: {} };

    (binding.modules['moe-article-list'] = {
        c: () => require('partner/modules/moe-article-list/moe-article-list.tsx'),
        $type: 'containerModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'moe-article-list',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/moe-article-list'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|moe-article-list|moe-article-list'] = {
                c: () => require('partner/modules/moe-article-list/moe-article-list.view.tsx'),
                cn: '__local__-__local__-moe-article-list'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };